export default __webpack_public_path__ + "static/three-b98fe28c025ed6a6bd8574f0481aaebb.png";